/* Yake Mall — sepete ekleme bildirimi (drawer kaldırıldı; sayfada kalıp küçük bildirim gösterilir). */
(function () {
  'use strict';
  function T(key, fallback) {
    var d = window.setMultiplierI18n || {};
    return d[key] != null ? String(d[key]) : fallback;
  }
  function cartUrl() {
    return (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_url) || '/cart';
  }
  function show(message) {
    var old = document.querySelector('.yake-add-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'yake-set-toast yake-add-toast';
    t.setAttribute('role', 'status');
    var icon = document.createElement('span');
    icon.className = 'yake-set-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';
    var msg = document.createElement('span');
    msg.className = 'yake-set-toast__message';
    msg.textContent = message;
    var link = document.createElement('a');
    link.href = cartUrl();
    link.textContent = T('viewCart', 'Sepete git');
    t.appendChild(icon);
    t.appendChild(msg);
    t.appendChild(link);
    document.body.appendChild(t);
    clearTimeout(show._timer);
    show._timer = setTimeout(function () {
      t.classList.add('yake-set-toast--leaving');
      setTimeout(function () { t.remove(); }, 300);
    }, 4000);
  }
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (!d || !d.isIncremental) return;
    if (d.source === 'yake-set' || d.source === 'yake-set-cart') return;
    if (d.didError) return;
    show(T('toastAdded', 'Ürün sepetinize eklendi'));
  });
})();
